var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "col-md-3 gridChoice",
      class: { optionSelected: _vm.compoQty != 0 },
    },
    [
      _c("div", { staticClass: "bgProd" }, [
        _c("div", { staticClass: "selectBox" }, [
          _c(
            "div",
            {
              staticClass:
                "prodImg d-flex justify-content-center align-items-center",
              on: {
                click: function ($event) {
                  return _vm.toggleCompo()
                },
              },
            },
            [
              _c("a", { staticClass: "cursor-pointer" }, [
                _c("img", {
                  class: {
                    "img-fit":
                      _vm.ShopService.shop.info.display.stretchProductImage,
                  },
                  attrs: {
                    src: _vm.UrlService.imagePath(
                      _vm.product.ShopId,
                      _vm.product.imt
                    ),
                    alt: _vm.product.dn,
                  },
                  on: {
                    error: function ($event) {
                      $event.target.src = "dist/assets/no-img.png"
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "ease-2 pos-absolute wh-100 bg-black-opacity-08 top-0 zindex-1",
              class: {
                "left-0 opacity-1": _vm.popInfoProdOpen,
                "left-100 opacity-0": !_vm.popInfoProdOpen,
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex-center-center flex-column wh-100" },
                [
                  _c(
                    "div",
                    { staticClass: "color-white text-bold fsize-12 mb-10" },
                    [_vm._v(_vm._s(_vm.infoAllergens(_vm.product)))]
                  ),
                  _vm._v(" "),
                  _c("product-tags", { attrs: { product: _vm.product } }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          (_vm.product.allergens && _vm.product.allergens.length) ||
          (_vm.product.consumables && _vm.product.consumables.length)
            ? _c(
                "div",
                {
                  staticClass:
                    "cursor-pointer hover-ko flex-center-center size-wh-30 bg-grey1 color-white m-10 mt-15 radius-50 pos-absolute top-0 right-0 zindex-1",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.popInfoProdOpen = !_vm.popInfoProdOpen
                    },
                  },
                },
                [
                  _c("i", {
                    class: {
                      "fie-icon_close  fsize-10": _vm.popInfoProdOpen,
                      "fie-icon_warning-eat fsize-18": !_vm.popInfoProdOpen,
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "overlayMe cursor-pointer zindex-0",
            on: {
              click: function ($event) {
                return _vm.toggleCompo()
              },
            },
          }),
          _vm._v(" "),
          _vm.category.ChoicesNumber !== 1 && _vm.compoQty > 0
            ? _c(
                "div",
                {
                  staticClass: "addCart plusMinus flex-center-center zindex-0",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "minus cursor-pointer",
                      style: { background: _vm.canDecrease() ? "" : "#b8b6b7" },
                      on: {
                        click: function ($event) {
                          return _vm.decreaseCompo()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon-eatselfapp_minus",
                        style: { color: _vm.canDecrease() ? "" : "#fff" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.compoQty))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "more cursor-pointer",
                      style: { background: _vm.canIncrease() ? "" : "#b8b6b7" },
                      on: {
                        click: function ($event) {
                          return _vm.increaseCompo()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon-eatselfapp_more",
                        style: { color: _vm.canIncrease() ? "" : "#fff" },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bottomImg" }, [
          !_vm.compoQty
            ? _c("div", { staticClass: "addCart justPlus" }, [
                _c(
                  "a",
                  {
                    staticClass: "more cursor-pointer",
                    style: { background: _vm.canIncrease() ? "" : "#b8b6b7" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleCompo()
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-eatselfapp_more" })]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.compoQty
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center selectedImgBox cursor-pointer",
                  on: {
                    click: function ($event) {
                      return _vm.toggleCompo()
                    },
                  },
                },
                [_c("i", { staticClass: "icon-eatselfapp_ok-bar" })]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "bottomProd d-flex flex-column justify-content-center align-items-center",
          },
          [
            _c("div", { staticClass: "choiceTitle" }, [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.menuCompo.product.dn) + "\n\t\t\t\t"
              ),
              _c("div", {
                staticClass:
                  "fsize-12 px-10 py-5 text-center size-max-h-40 no-overflow text-regular",
                staticStyle: { "line-height": "18px" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.truncate(
                      _vm.menuCompo.product.dd,
                      _vm.DISPLAY_LENGTH.mosaic.product.desc
                    )
                  ),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "price" }, [
                _vm.price ? _c("span", [_vm._v("+")]) : _vm._e(),
                _vm._v(_vm._s(_vm.ShopService.prix(_vm.price))),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }